module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/~/babel-runtime/core-js/object/define-property.js
// module id = 1763
// module chunks = 0